import { render, staticRenderFns } from "./VoipServiceKitGuide.vue?vue&type=template&id=d117b734&scoped=true"
import script from "./VoipServiceKitGuide.vue?vue&type=script&lang=js"
export * from "./VoipServiceKitGuide.vue?vue&type=script&lang=js"
import style0 from "./VoipServiceKitGuide.vue?vue&type=style&index=0&id=d117b734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d117b734",
  null
  
)

export default component.exports